import { supabase } from '@/integrations/supabase/client';

export interface EmailUnsubscribe {
  id: string;
  email: string;
  lead_id: string | null;
  company_id: string | null;
  unsubscribed_from: string[];
  global_unsubscribe: boolean;
  reason: string | null;
  unsubscribed_at: string;
  created_at: string;
  updated_at: string;
}

export async function fetchUnsubscribes(companyId?: string): Promise<EmailUnsubscribe[]> {
  let query = supabase
    .from('email_unsubscribes')
    .select('*')
    .order('unsubscribed_at', { ascending: false });

  if (companyId) {
    query = query.or(`company_id.eq.${companyId},global_unsubscribe.eq.true`);
  }

  const { data, error } = await query;
  if (error) throw error;
  return (data || []) as unknown as EmailUnsubscribe[];
}

export async function addUnsubscribe(email: string, reason?: string, companyId?: string): Promise<EmailUnsubscribe> {
  const insertData: Record<string, unknown> = {
    email,
    global_unsubscribe: !companyId,
    reason: reason || null,
  };
  if (companyId) {
    insertData.company_id = companyId;
  }

  const { data, error } = await supabase
    .from('email_unsubscribes')
    .insert(insertData as any)
    .select()
    .single();
  if (error) throw error;
  return data as unknown as EmailUnsubscribe;
}

export async function removeUnsubscribe(id: string): Promise<void> {
  const { error } = await supabase
    .from('email_unsubscribes')
    .delete()
    .eq('id', id);
  if (error) throw error;
}
